import { configureStore } from '@reduxjs/toolkit';
import { AppReducer } from '../AppReducer';
import EdvisorLoginReducer from '../components/EdvisorLoginReducer';
import NoticeReducer from '../components/Notice/NoticeReducer';
import TaskReducer from "../components/task/TaskReducer";
import EmployeeReducer from '../components/employee/EmployeeReducer';
import LeadReducer from '../components/lead/LeadReducer';
import ClientReducer from '../components/service/ServiceReducer';

export const store = configureStore({
  reducer: {
    edvisorLogin: EdvisorLoginReducer,
    app: AppReducer,
    notice: NoticeReducer,
    task: TaskReducer,
    employee: EmployeeReducer,
    lead: LeadReducer,
    client: ClientReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});